<template>
    <div class="login-container">
        <div class="user">
            <h4>欢迎注册</h4>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
                <!-- <el-form-item label="用户名" prop="username" >
                    <el-input v-model="ruleForm.username" placeholder="请输入用户名"></el-input>
                </el-form-item> -->
                <el-form-item label="用户名" >
                    <el-input v-model="ruleForm.username" placeholder="请输入用户名" ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input v-model="ruleForm.password" type="password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="repassword">
                    <el-input v-model="ruleForm.repassword" type="password" placeholder="请再确认一次密码"></el-input>
                </el-form-item>
                <el-form-item label="企业名称" prop="pany">
                    <el-input v-model="ruleForm.pany" placeholder="请输入企业名称"></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="tact">
                    <el-input v-model="ruleForm.tact" placeholder="请输入联系人"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" >
                    <el-input v-model="ruleForm.email" placeholder="请输入邮箱 "></el-input>
                </el-form-item>
                <el-form-item label="地址" >
                    <el-input v-model="ruleForm.adress" placeholder="请输入地址"> </el-input>
                </el-form-item>
                <el-form-item label="职务" >
                    <el-input v-model="ruleForm.job" placeholder="请输入职务"></el-input>
                </el-form-item>
                <el-form-item label="网址" >
                    <el-input v-model="ruleForm.web" placeholder="请输入网址"></el-input>
                </el-form-item>
                <el-form-item label="企业法人" >
                    <el-input v-model="ruleForm.person" placeholder="请输入企业法人"></el-input>
                </el-form-item>
                
                <!-- <el-form-item label="企业简介" >
                    <el-input type="textarea" v-model="ruleForm.syn" placeholder="请输入企业简介"></el-input>
                </el-form-item>
                <el-form-item label="营业执照" prop="license">
                    <button type="button">上传营业执照</button>
                    <input type="file" @change="upLicense($event)" accept="image/*" >
                </el-form-item>
                <el-form-item label="税务登记证" prop="reg">
                    <button type="button">上传税务登记证</button>
                    <input type="file" @change="upReg($event)" accept="image/*" >
                </el-form-item>
                <el-form-item label="组织结构代码证" prop="code">
                    <button type="button">上传组织结构代码证</button>
                    <input type="file" @change="upCode($event)" accept="image/*">
                </el-form-item>
                <el-form-item label="总经理任命书" prop="letter">
                    <button type="button">上传总经理任命书</button>
                    <input type="file" @change="upLetter($event)" accept="image/*" >
                </el-form-item> -->

                    
                
            </el-form>
            <span style="margin-left:20%;float:left;">
                <span style="float:left;margin-right:10px;">
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;color:#f00;" v-if="showone">+</div>
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;" v-else>-</div>
                    <div style="text-align:left;">营业执照</div>
                     <input type="file" @change="upLicense($event)" accept="image/*" >
                </span>
                <span style="float:left;margin-right:4px;">
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;color:#f00;" v-if="showtwo">+</div>
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;" v-else>-</div>
                    <div style="text-align:left;">组织结构代码证</div>
                    <input type="file" @change="upReg($event)" accept="image/*" >
                </span>
                <span style="float:left;margin-right:10px;">
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;color:#f00;" v-if="showsan">+</div>
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;" v-else>-</div>
                    <div style="text-align:left;">税务登记证</div>
                    <input type="file" @change="upCode($event)" accept="image/*">
                </span>
                <!-- <span style="float:left;">
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;color:#f00;" v-if="showfou">+</div>
                    <div style="width:50px;height:50px;border:1px dashed #999;color:#000;font-size:30px;line-height:50px;margin-left:20%;" v-else>-</div>
                    <div style="text-align:left;">总经理任命书</div>
                    <input type="file" @change="upLetter($event)" accept="image/*" >
                </span> -->
            </span>
            
            <br>
            <br>
            <br>
            <br>
            <br>
            <el-button type="primary" @click="logonFunc()" style="float:left;">注册</el-button>
            <el-button type="primary" @click="goOut()" style="float:left;">返回</el-button>
        </div>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            


            ruleForm: {
                username:"",  //账号
                password:"",  //密码
                repassword:"",  //确认密码
                pany:"",    //公司名称
                email:"",   //邮箱
                tact:"",    //联系人
                phone:"",   //联系方式
                adress:"",  //地址
                job:"",     //职务
                web:"",     //网址
                person:"",  //法人
                syn:"",      //简介
                license:"",  //营业执照
                reg:"",      //登记证
                code:"",    //代码证
                letter:"",   //任命书
            },
            rules: {
                // username: [
                //     { required: true, message: '请输入账号', trigger: 'blur' },
                //     { min: 7, max: 12, message: '请输入7-12个字符', trigger: 'blur' }
                // ],
                password:[
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 7, max: 12, message: '请输入7-12个字符', trigger: 'blur' }
                ],
                repassword:[
                    { required: true, message: '请再次确认密码', trigger: 'blur' },
                    { min: 7, max: 12, message: '请输入7-12个字符', trigger: 'blur' }
                ],
                pany: [
                    { required: true, message: '请填写企业名称', trigger: 'blur' }
                ],
                tact:[
                    { required: true, message: '请输入联系人', trigger: 'change' },
                ],
                phone:[
                    { required: true, message: '请输入联系方式', trigger: 'change' },
                ],
                license:[
                    { required: true, message: '请上传营业执照', trigger: 'change' },
                ],
                reg:[
                    { required: true, message: '请上传税务登记证', trigger: 'change' },
                ],
                code:[
                    { required: true, message: '请上传组织结构代码证', trigger: 'change' },
                ],
                letter:[
                    { required: true, message: '请上传总经理任命书', trigger: 'change' },
                ],
            },
            showone:true,
            showtwo:true,
            showsan:true,
            showfou:true,
        }
    },
    mounted() {
        // this.logonFunc();
    },
    methods: {
        
        //返回到首页
        goOut(){
            this.$router.push({path:"/"})
        },
        logonFunc(){
            //依次判断必填项
            if(!this.ruleForm.username){
                this.$message.error('请填入用户名');
                return
            }
            // if(this.ruleForm.username.length<7 || this.ruleForm.username.length>12){
            //     this.$message.error('用户名请输入7-12个字符');
            //     return
            // }
            
            var reg = /^[A-Za-z0-9]{1,30}$/; //正则 英文+数字；
            if(!reg.test(this.ruleForm.username)){
                this.$message.error("请输入字母或数字组成的账号名称");
                return 
            }
            if(!this.ruleForm.password){
                this.$message.error('请填入密码');
                return
            }
            if(this.ruleForm.password.length<7 || this.ruleForm.password.length>12){
                this.$message.error('密码请输入7-12个字符');
                return
            }
            //判断密码和确认密码  是否一致
            if(this.ruleForm.password != this.ruleForm.repassword){
                this.$message.error('请确认两次输入的密码一致');
                return
            }
            if(!this.ruleForm.pany){
                this.$message.error('请填入公司名称');
                return
            }
            if(!this.ruleForm.tact){
                this.$message.error('请填入联系人');
                return
            }
            if(!this.ruleForm.phone){
                this.$message.error('请填入联系方式');
                return
            }
            //验证手机号
            var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if(!myreg.test(this.ruleForm.phone)){
                this.$message.error('请输入正确的联系方式');
                return
            }
            //验证邮箱
            var reg1=/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
            if(this.ruleForm.email !=''){
                if(!reg1.test(this.ruleForm.email)){
                    this.$message.error('请输入正确的邮箱格式');
                    return
                }
            }
            
            if(this.ruleForm.license== "" && this.ruleForm.reg== "" && this.ruleForm.code== ""&&this.ruleForm.letter== "" ){
                // this.$message.wa('当前未上传所需要的文件');
                this.$message({
                    message: '当前未上传所需要的文件',
                    type: 'warning'
                });
                // return
            }
            // if(this.ruleForm.reg== "" ){
            //     this.$message.error('请上传税务登记证');
            //     return
            // }
            // if(this.ruleForm.code== "" ){
            //     this.$message.error('请上传组织结构代码证');
            //     return
            // }
            // if(this.ruleForm.letter== "" ){
            //     this.$message.error('请上传总经理任命书');
            //     return
            // }
            // let {username,password,pany,repassword,email,tact,phone} =this;
            
                this.$axios.post("/register",{
                    userName:this.ruleForm.username,
                    userPassword:this.ruleForm.password,
                    userEmail:this.ruleForm.email,
                    userCompany:this.ruleForm.pany,
                    companyAddress:this.ruleForm.adress,
                    companyLinkman:this.ruleForm.tact,
                    userWork:this.ruleForm.job,
                    userPhonenum:this.ruleForm.phone,
                    companyWebsite:this.ruleForm.web,
                    companyLegalperson:this.ruleForm.person,
                    companyInfo:this.ruleForm.syn,
                    userUrlYyzz:this.ruleForm.license,
                    userUrlSwdjz:this.ruleForm.reg,
                    userUrlZzjgdmz:this.ruleForm.code,
                    userUrlJlrms:this.ruleForm.letter
                    
                }).then(res=>{
                    if(res.data.success){
                        
                        this.$message({
                            message: '注册成功,请登录',
                            type: 'success'
                        });
                        this.$router.push({path:"/login"})
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                    }
                })
            
        },
        //上传营业执照
        upLicense(e){
            this.showone = false
            this.file = event.target.files[0];
            let formData = new FormData();
            formData.append("file",this.file);
            formData.append('name',this.name);

            this.$axios.post('/img/upload',formData)
            .then(data=>{
                if(data.data.success){
                    
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.ruleForm.license = data.data.data;
                }
            })
        },
        //
        upReg(e){
            this.showtwo = false;
            this.file = event.target.files[0];
            let formData = new FormData();
            formData.append("file",this.file);
            formData.append('name',this.name);

            this.$axios.post('/img/upload',formData)
            .then(data=>{
                if(data.data.success){
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.ruleForm.reg = data.data.data;
                }
            })
        },
        //
        upCode(e){
            this.showsan = false;
           this.file = event.target.files[0];
            let formData = new FormData();
            formData.append("file",this.file);
            formData.append('name',this.name);

            this.$axios.post('/img/upload',formData)
            .then(data=>{
                if(data.data.success){
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.ruleForm.code = data.data.data;
                }
            }) 
        },
        //
        upLetter(e){
            this.showfou = false;
            this.file = event.target.files[0];
            let formData = new FormData();
            formData.append("file",this.file);
            formData.append('name',this.name);

            this.$axios.post('/img/upload',formData)
            .then(data=>{
                if(data.data.success){
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });
                    this.ruleForm.letter = data.data.data;
                }
            })
        }
    },
}
</script>

<style scoped >
    .login-container {
        position: absolute;
        width: 100%;
        height: 100%;
        background: url("../assets/bg.png") no-repeat;
        background-size: 100% 100%;
    }
    .user{
        position: absolute;
        top:14%;
        left:14%;
        width:40%;
        height:660px;
        min-height:660px;
        text-align: center;
        overflow-y:scroll;
        opacity: 0.9;
        background-color: #fff;
    }
    
    .user h4{
        font-size:32px;
        margin:20px 0;
    }
    .user .el-input{
        
    }
    .user .el-input,.el-textarea{
        width:70%;
        margin-left:-20%;
    }
    
    .user .el-button{
        margin-bottom:20px; 
        margin-left:20%;
    }
    .user button{
        text-align: justify;
        border:0;
        outline: none;
        box-sizing: border-box;
        background-color:#409EFF;
    }
    .user input[type='file']{
        /* margin-left:-120px; */
        opacity: 0;
        margin-top:-100%;
        width:100px;
        height:100px;
        float:left;
    }
</style>
<style >
    .user .el-input__inner{
        height:50px;
        line-height:50px;
        color:#000;
        font-size:18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/logonPage.vue